/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OptionDto_Guid } from '../models/OptionDto_Guid';
import type { Wealthlane_AppServices_Features_CompanyFeatureSetDto } from '../models/Wealthlane_AppServices_Features_CompanyFeatureSetDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyFeatureService {

    /**
     * @param id 
     * @returns Wealthlane_AppServices_Features_CompanyFeatureSetDto OK
     * @throws ApiError
     */
    public static getApiIdentityCompanyFeaturePermissions(
id: string,
): CancelablePromise<Array<Wealthlane_AppServices_Features_CompanyFeatureSetDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/company/feature/permissions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AppServices_Features_CompanyFeatureSetDto OK
     * @throws ApiError
     */
    public static getApiIdentityCompanyFeaturePermissions1(
id?: string,
): CancelablePromise<Array<Wealthlane_AppServices_Features_CompanyFeatureSetDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/company/feature/permissions',
            query: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns OptionDto_Guid OK
     * @throws ApiError
     */
    public static getApiIdentityCompanyFeatureSet(
id?: string,
): CancelablePromise<Array<OptionDto_Guid>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/company/feature-set',
            query: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns OptionDto_Guid OK
     * @throws ApiError
     */
    public static getApiIdentityCompanyFeatureSet1(
id: string,
): CancelablePromise<Array<OptionDto_Guid>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/company/feature-set/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
